// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pNCH","footer":"styles_footer__2jpiW"};